import PayMain from "@/components/dashboard/pay/PayMain";

export default function Pay() {
  return <PayMain />;
}
